import Link from 'next/link'
import PropTypes from 'prop-types'
import React from 'react'
import Swiper from 'react-id-swiper'
import clsx from 'clsx'
import Loader from 'components/loader'
import ProductItem from 'components/product/product-item'
import ProductList from 'components/product/product-list'
import ResponsiveImage from 'components/images/responsive-image'
import Button from 'components/common/button'
import { BUTTON_TYPES } from 'constants/button'
import Typo from 'constants/typography'
import { PURPOSE_SHOP_COLLECTION, PURPOSE_SHARED } from 'pages/purpose/const'
import { hasLocizeTranslation } from 'lib/utils/locize'
import { SEGMENT_STORAGE_KEY_CATEGORY } from 'lib/segment/const'
import styles from './styles.scss'

const sliderOptions = {
  spaceBetween: 10,
  slidesPerView: 2.3,
  roundLengths: true,
}

function renderProductItem(product, idx) {
  return (
    <ProductItem
      key={product.id_product}
      displayBackInStock={false}
      displayDescription
      displayPrice
      idx={idx + 1}
      refId="purpose"
      refType="purpose_landing_page"
      promptLocation="wishlist_category"
      {...product}
    />
  )
}

function renderProducts(products, isPhone) {
  if (!products) {
    return (
      <div className="loader-container">
        <Loader />
      </div>
    )
  }

  return (
    <div className="purpose-sc__product-wrapper">
      {isPhone ? (
        <Swiper {...sliderOptions}>{products.map(renderProductItem)}</Swiper>
      ) : (
        <ProductList
          displayDescription
          displayPrice
          list={products}
          refId="purpose"
          refType="purpose_landing_page"
          promptLocation="wishlist_category"
        />
      )}
    </div>
  )
}

function onLinkClicked() {
  sessionStorage.setItem(SEGMENT_STORAGE_KEY_CATEGORY.id, 'purpose_2019')
  sessionStorage.setItem(SEGMENT_STORAGE_KEY_CATEGORY.position, '')
  sessionStorage.setItem(SEGMENT_STORAGE_KEY_CATEGORY.type, 'landing_page')
  sessionStorage.setItem(SEGMENT_STORAGE_KEY_CATEGORY.subPos, '')
}

const PurposeShopCollection = ({ isPhone, products, t }) => {
  const image = PURPOSE_SHOP_COLLECTION.image[isPhone ? 0 : 1]

  return (
    <React.Fragment>
      <style jsx>{styles}</style>
      <ResponsiveImage
        className={clsx(Typo.h4, 'purpose-sc__image')}
        imgRatio={image.ratio}
        src={image.src}
      >
        <div className="overlay">
          {hasLocizeTranslation(
            t,
            PURPOSE_SHOP_COLLECTION.descKey,
            PURPOSE_SHOP_COLLECTION.desc,
          )}
        </div>
      </ResponsiveImage>
      <div className="purpose-sc__subtitle-wrapper">
        <span className={Typo.body2}>
          {hasLocizeTranslation(
            t,
            PURPOSE_SHOP_COLLECTION.subtitleKey,
            PURPOSE_SHOP_COLLECTION.subtitle,
          )}
        </span>
      </div>
      <div className="purpose-sc__bottom-wrapper">
        <Link
          href={PURPOSE_SHARED.shopCollectionHref}
          as={PURPOSE_SHARED.shopCollectionAs}
        >
          <a>
            <Button
              className="purpose-sc__cta"
              type={BUTTON_TYPES.primary}
              onClickCapture={onLinkClicked}
            >
              {hasLocizeTranslation(
                t,
                PURPOSE_SHOP_COLLECTION.ctaKey,
                PURPOSE_SHOP_COLLECTION.cta,
              )}
            </Button>
          </a>
        </Link>
        {renderProducts(products, isPhone)}
      </div>
    </React.Fragment>
  )
}

PurposeShopCollection.defaultProps = {
  products: null,
}

PurposeShopCollection.propTypes = {
  isPhone: PropTypes.bool.isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({})),
  t: PropTypes.func.isRequired,
}

export default PurposeShopCollection
